var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftAuthenticatorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6087_232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3611 0.488281C22.2256 0.488281 27.0086 5.11567 27.2604 10.9188C26.7142 10.7269 26.1386 10.5934 25.5432 10.5258C24.5674 10.4149 23.5965 10.322 22.6302 10.2465C22.0874 7.27673 19.4872 5.02571 16.3611 5.02571C13.2349 5.02571 10.6347 7.27673 10.0919 10.2465C9.12565 10.322 8.15473 10.4149 7.17887 10.5258C6.58349 10.5934 6.00793 10.7269 5.46167 10.9188C5.71354 5.11567 10.4965 0.488281 16.3611 0.488281Z",
    fill: "#205694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3612 9.99557C19.3756 10.0013 22.4348 10.1726 25.5434 10.5258C29.1449 10.9349 32.0248 13.7421 32.0248 17.4092C32.0248 31.8784 20.8298 39.202 16.3612 39.3772C11.8926 39.202 0.69751 31.8784 0.69751 17.4092C0.69751 13.7421 3.57749 10.9349 7.17899 10.5258C10.2875 10.1726 13.3468 10.0013 16.3612 9.99557Z",
    fill: "url(#paint0_linear_6087_232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3611 25.5527C21.3069 25.5527 25.4433 28.7628 26.4805 33.0582C22.9988 37.1776 18.7327 39.2842 16.3611 39.3772C13.9895 39.2842 9.72342 37.1776 6.2417 33.0582C7.27887 28.7628 11.4155 25.5527 16.3611 25.5527Z",
    fill: "url(#paint1_linear_6087_232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.361 23.9322C19.2844 23.9322 21.6542 21.5621 21.6542 18.6384C21.6542 15.7147 19.2844 13.3445 16.361 13.3445C13.4377 13.3445 11.0679 15.7147 11.0679 18.6384C11.0679 21.5621 13.4377 23.9322 16.361 23.9322Z",
    fill: "url(#paint2_linear_6087_232)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6087_232",
    x1: 16.3612,
    y1: 39.3772,
    x2: 16.3612,
    y2: 9.99557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0275D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6087_232",
    x1: 16.3611,
    y1: 39.3772,
    x2: 16.3611,
    y2: 25.5527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A99E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C5FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6087_232",
    x1: 16.361,
    y1: 23.9322,
    x2: 16.361,
    y2: 13.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A99E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46C5FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6087_232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.5926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftAuthenticatorLogo);
export default __webpack_public_path__ + "static/media/microsoft-authenticator-logo.2988bbcbd8740814f5d2f1a001bebd86.svg";
export { ForwardRef as ReactComponent };